import { TRPCError } from '@trpc/server'

export function getStateIndex<T extends string | number>(
  states: T[],
  editedState: T,
) {
  const stateIndex = states.findIndex((state) => state === editedState)
  if (stateIndex === -1) {
    throw new TRPCError({
      code: 'NOT_FOUND',
      message: `State ${editedState} not found in variable.`,
    })
  }
  return stateIndex
}
